import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type SubmitRecipientProfilePayloadType = {
  filled_by: 'recipient' | 'proxy';
  fields: Record<string, string>;
  confirmation_channel: '' | 'email' | 'phone';
  confirmation_contact: string;
  save_to_own_vault: boolean;
};

export const submitRecipientProfileApi = (
  token: string,
  data: SubmitRecipientProfilePayloadType
): Promise<ApiResponseType<{ submitted: boolean; record_hash: string; organization: string }>> =>
  apiService.POST(`/recipient-requests/${token}/submit/`, data);
